import React from "react";
import {
    Container,
    Content,
    Description,
    Hero,
    SignIn,
    SignInContainer,
    Title,
} from "@Styled/Pages/ForgotPassword";
import { Header, RenewPasswordForm } from "@Components";
import { IRenewPassword } from "@Interfaces";

const RenewPassword: React.FC<IRenewPassword.IProps> = () => {
    return (
        <>
            <Hero>
                <Header showNav={false} showJoinButton={true} />
                <Container>
                    <Content>
                        <Title>Reset Password</Title>
                        <Description>
                            Almost there, choose your new password.
                        </Description>
                    </Content>
                    <SignIn>
                        <SignInContainer>
                            <RenewPasswordForm />
                        </SignInContainer>
                    </SignIn>
                </Container>
            </Hero>
        </>
    );
};

export default RenewPassword;
